import { PaginatedRequest } from '@clean-code/types/common';

export const SET_OPERATOR_LIST_SORTING =
  'OPERATOR_SETTINGS/SET_OPERATOR_LIST_SORTING';
export const SET_OPERATOR_LIST_PAGINATION =
  'OPERATOR_SETTINGS/SET_OPERATOR_LIST_PAGINATION';
export const SET_OPERATOR_PLANNING_SORTING =
  'OPERATOR_SETTINGS/SET_OPERATOR_PLANNING_SORTING';
export const SET_OPERATOR_PLANNING_PAGINATION =
  'OPERATOR_SETTINGS/SET_OPERATOR_PLANNING_PAGINATION';

export type OperatorSettingsSorting = {
  column: string;
  direction: 'asc' | 'desc';
};

export type OperatorSettingsState = {
  operatorList: {
    sorting: OperatorSettingsSorting;
    pagination: PaginatedRequest;
  };
  operatorPlanning: {
    sorting: OperatorSettingsSorting;
    pagination: Required<Pick<PaginatedRequest, 'page' | 'pageSize'>>;
  };
};
